/* yenkoes micro-delights — a gold ✦ pop on the header cart icon whenever the
   cart re-renders (add to cart, quantity change). The icon's contents are
   replaced by cart.js / product-form.js section rendering, so a MutationObserver
   on the anchor catches every update. Skipped under prefers-reduced-motion. */
(function () {
  function init() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var timer = null;
    new MutationObserver(function () {
      icon.classList.remove('yk-cart-pop');
      void icon.offsetWidth; // restart the animation
      icon.classList.add('yk-cart-pop');
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { icon.classList.remove('yk-cart-pop'); }, 1000);
    }).observe(icon, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
